import React from "react";

// A blog hero is not the same thing as a page banner.
//
// HeroImageSection crops its image into a fixed 430px band and then clips a
// wave and a button notch out of the bottom. That is the right treatment for
// About or Services, where the image is decorative photography. Blog heroes
// are designed graphics -- headline, wordmark, an icon row along the bottom
// edge -- and on a 1440px screen that band was cutting roughly 45% of the
// image height, taking the icon row with it.
//
// So: no fixed height and no clip. The image sets its own height and every
// pixel survives. Width is capped at the article column rather than running
// full-bleed, which also keeps the 1024px sources from being upscaled into
// softness.
const BlogHero = ({ image, alt, width, height }) => {
  if (!image) return null;

  return (
    <div className="w-full bg-white py-8">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-8">
        <img
          src={image}
          alt={alt}
          // Intrinsic size, so the browser reserves the correct box before
          // the file arrives. Without it the largest element on the page
          // would collapse and then push everything down as it loads.
          width={width || undefined}
          height={height || undefined}
          fetchpriority="high"
          decoding="async"
          className="w-full h-auto rounded-[28px] border border-[#edf1ed] shadow-sm"
        />
      </div>
    </div>
  );
};

export default BlogHero;
